import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import moment from 'moment';
import Swal from "sweetalert2";
import { useParams } from "react-router-dom";
import { Modal } from 'react-bootstrap';

import PropertyMap from './components/PropertyMap';
import VideoSection from './components/VideoSection';
import DemoSlider from './DemoSlider';
import property1 from '../../../images/property/1.jpg';

import {
  getPropertyAction,
  updatePropertyAction
} from '../../../store/actions/property/PropertyActions';

function PropertyDetails() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const [fromReported, setFromReported] = useState(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.location && typeof window.location.search === 'string') {
      const params = new URLSearchParams(window.location.search);
      if (params.get('nfrm') === 'rptd') {
        setFromReported(true);
      }
    }
  }, []);

  const { auth } = useSelector((state) => state.auth);
  const [userPolicies , setUserPolicies ] = useState([]);


  const { property, loading } = useSelector(state => state.property);
  const [adStatus, setAdStatus] = useState(property?.adStatus);
  const [blockModal, setBlockModal] = useState(false);
  const [blockNote, setBlockNote] = useState('')
  const [modalTitle, setModalTitle] = useState('Block Property')
  const [modalMode, setModalMode] = useState('block')

  const updateAddStatus = async (status) => {
    const payload = {
      adStatus: status
    }
    const response = await dispatch(updatePropertyAction(property._id, payload));
    if (response.data.success) {
      Swal.fire({ icon: 'success', title: 'Success!', text: 'Property Status updated' });
      setAdStatus(status);
    } else {
      Swal.fire({ icon: 'error', title: 'Error', text: response.data?.msg || 'Something went wrong' });
    }
  }

  const handleAddFormSubmit = async (event) => {
		event.preventDefault();
    if(modalMode === 'block') {
      const payload = {
        adStatus: 'blocked',
        adStatusNote : blockNote
      }
      const response = await dispatch(updatePropertyAction(property._id, payload));
      setBlockModal(false);
      if (response.data.success) {
        Swal.fire({ icon: 'success', title: 'Success!', text: 'Property blocked successfully' });
        setAdStatus('blocked');
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: response.data?.msg || 'Something went wrong' });
      }
    } else if(modalMode === 'rejected') {
      const payload = {
        adStatus: 'rejected',
        adStatusNote : blockNote
      }
      const response = await dispatch(updatePropertyAction(property._id, payload));
      setBlockModal(false);
      if (response.data.success) {
        Swal.fire({ icon: 'success', title: 'Success!', text: 'Property rejected successfully' });
        setAdStatus('rejected');
      } else {
        Swal.fire({ icon: 'error', title: 'Error', text: response.data?.msg || 'Something went wrong' });
      }
    }
  }

  const resetForm = () => {
		setBlockModal(false);
		setBlockNote('');
	};

  useEffect(() => {
    setAdStatus(property?.adStatus); // update if Redux changes
  }, [property]);

  useEffect(() => {
    dispatch(getPropertyAction(id, 'propertyTypeId,listingTypeId,amenityIds,featureIds,availabilityStatusId,facingDirectionId,ownershipTypeId,furnishingStatusId,priceUnitId,areaUnitId,carpetAreaUnitId,builtUpAreaUnitId,superBuiltAreaUnitId,customerId'));
  }, [id, dispatch]);

  useEffect(() => {
    setUserPolicies(auth?.userPolicy?.policy)
  },[auth]);

  return (
    <>
      {loading ? (
        <div className="container py-5">
          <div className="row">
            <div className="col-12 mb-4">
              <div className="skeleton" style={{ 
                width: 240, 
                height: 32, 
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', 
                backgroundSize: '200% 100%',
                animation: 'loading 1.5s infinite',
                borderRadius: 6, 
                marginBottom: 16 
              }} />
              <div className="skeleton" style={{ 
                width: 120, 
                height: 20, 
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', 
                backgroundSize: '200% 100%',
                animation: 'loading 1.5s infinite',
                borderRadius: 4, 
                marginBottom: 8 
              }} />
            </div>
            <div className="col-md-6 mb-4">
              <div className="skeleton" style={{ 
                width: '100%', 
                height: 320, 
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', 
                backgroundSize: '200% 100%',
                animation: 'loading 1.5s infinite',
                borderRadius: 8 
              }} />
            </div>
            <div className="col-md-6 mb-4">
              <div className="skeleton" style={{ 
                width: '100%', 
                height: 320, 
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', 
                backgroundSize: '200% 100%',
                animation: 'loading 1.5s infinite',
                borderRadius: 8 
              }} />
            </div>
            <div className="col-12">
              <div className="skeleton" style={{ 
                width: '100%', 
                height: 180, 
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)', 
                backgroundSize: '200% 100%',
                animation: 'loading 1.5s infinite',
                borderRadius: 8 
              }} />
            </div>
          </div>
          <style jsx>{`
            @keyframes loading {
              0% { background-position: 200% 0; }
              100% { background-position: -200% 0; }
            }
          `}</style>
        </div>
      ) : property && Object.keys(property).length > 0 && (
        <>
          <div className="form-head page-titles d-flex  align-items-center">
            <Modal className="modal fade" show={blockModal} onHide={resetForm}>
              <form onSubmit={handleAddFormSubmit}>
                <div className="modal-header">
                  <h4 className="modal-title fs-20">{modalTitle}</h4>
                  <button type="button" className="btn-close" onClick={resetForm}></button>
                </div>
                <div className="modal-body">
                  <div className="add-contact-box">
                    <div className="add-contact-content">
                      <div className="form-group mb-3">
                        <label>Reason</label>
                        <input 
                          type="text" 
                          className={`form-control`}
                          value={blockNote}
                          onChange={(e) => setBlockNote(e.target.value)} 
                          placeholder="Reason"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="submit" className="btn btn-primary">{modalMode === 'block' ? 'Block' : 'Reject'}</button>
                  <button type="button" className="btn btn-danger" onClick={resetForm}>Cancel</button>
                </div>
              </form>
            </Modal>
            <div className="me-auto  d-lg-block">
              <h4 className="mb-1">Property Details</h4>
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">
                  Property
                </li>
                <li className="breadcrumb-item">
                  {property.title}
                </li>
              </ol>
            </div>
            {userPolicies.includes('POL0009') && (
            <>
              {adStatus === 'active' ? (
                <>
                  <button onClick={() => {setBlockModal(true); setModalTitle('Block Property');setModalMode('block');}} className="btn btn-danger rounded me-3">
                    Mark As Block
                  </button>
                  {fromReported ? null : (
                    <button onClick={() => updateAddStatus('pending')} className="btn btn-primary rounded me-3">
                      Mark As Pending
                    </button>
                  )}
                  {/* <button onClick={() => updateAddStatus('deactivated')} className="btn btn-danger rounded me-3">
                    Deactivate
                  </button> */}
                </>
              ) : adStatus === 'pending' ? (
                <>
                  <button onClick={() => updateAddStatus('active')} className="btn btn-success rounded me-3">
                    Mark As Active
                  </button>
                  <button onClick={() => {setBlockModal(true); setModalTitle('Reject Property');setModalMode('rejected');}} className="btn btn-danger rounded me-3">
                    Mark As Rejected
                  </button>
                </>
              ) : adStatus === 'blocked' || adStatus === 'rejected' ? (
                <button onClick={() => updateAddStatus('active')} className="btn btn-danger rounded me-3">
                  Mark As Active
                </button>
              ) : adStatus === 'sold' ? (
                <button className="btn btn-success rounded me-3">Sold</button>
              ):(
                <></>
              )}
            </>
            )}
          </div>
          <div className="row">
            <div className="col-xl-3 col-xxl-4">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card bg-primary text-center">
                    <div className="card-body">
                      <h2 className="fs-30 text-white">{property?.listingTypeId?.name}</h2>
                      <span className="text-white font-w300">
                        ₹ {property?.priceUnitId?.name} {Number(property.price).toLocaleString()}
                      </span>
                    </div>
                  </div>
                </div>
                
                <div className="col-xl-12 col-lg-6 col-md-6">
                  <div className="card">
                    <div className="card-header mb-0 border-0">
                      <h3 className="fs-20 text-black">Property Location</h3>
                    </div>
                    <div className="card-body pt-0 text-center">
                      <PropertyMap latitude={property.latitude} longitude={property.longitude} />
                    </div>
                  </div>
                </div>
                {property.videoUrl && (
                  <div className="col-xl-12 col-lg-6 col-md-6">
                    <div className="card">
                      <div className="card-header mb-0 border-0">
                        <h3 className="fs-20 text-black">Property Video</h3>
                      </div>
                      <div className="card-body pt-0 text-center">
                        <VideoSection videoUrl={property.videoUrl} />
                      </div>
                    </div>
                  </div>
                )}

                {property.virtualTourUrl && (
                  <div className="col-xl-12 col-lg-6 col-md-6">
                    <div className="card">
                      <div className="card-header mb-0 border-0">
                        <h3 className="fs-20 text-black">Virtual Tour</h3>
                      </div>
                      <div className="card-body pt-0 text-center">
                        <VideoSection videoUrl={property.virtualTourUrl} />
                      </div>
                    </div>
                  </div>
                )}
                <div className="col-xl-12 col-lg-6 col-md-6">
                  <div className="card">
                    <div className="card-header mb-0 border-0">
                      <h3 className="fs-20 text-black">Property Owner</h3>
                    </div>
                    <div className="card-body pt-0">
                      <div className="d-flex align-items-center mb-3">
                        <div className="property-media me-3">
                          <img 
                            src={property.customerId?.profilePicture || property1}
                            alt="Owner"
                            style={{
                              width: '60px',
                              height: '60px',
                              borderRadius: '50%',
                              objectFit: 'cover'
                            }}
                            onError={(e) => {
                              e.target.onerror = null; 
                              e.target.src = property1; 
                            }}
                          />
                        </div>
                        <div>
                          <h6 className="mb-1 fs-16 font-w600">{property.customerId?.name}</h6>
                          <p className="mb-0 text-muted fs-14">{property.customerId?.email}</p>
                        </div>
                      </div>
                      
                      {property.customerId?.phone && (
                        <div className="mb-2">
                          <span className="fs-14 text-black font-w600">Phone: </span>
                          <span className="fs-14 text-muted">{property.customerId?.phone}</span>
                        </div>
                      )}
                      
                      {property.customerId?.address && (
                        <div className="mb-2">
                          <span className="fs-14 text-black font-w600">Address: </span>
                          <span className="fs-14 text-muted">{property.customerId?.address}</span>
                        </div>
                      )}
                      
                      <div className="mb-2">
                        <span className="fs-14 text-black font-w600">Member Since: </span>
                        <span className="fs-14 text-muted">
                          {moment(property.customerId?.createdAt).format('MMM YYYY')}
                        </span>
                      </div>
                      
                      {property.customerId?.isVerified && (
                        <div className="mt-3">
                          <span className="badge badge-success">
                            <i className="las la-check-circle me-1"></i>
                            Verified User
                          </span>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-9 col-xxl-8 property-detail-card">
              <div className="row">
                <div className="col-xl-12">
                  <div className="card">
                    <div className="card-body">
                      <div className="property-card style-1 mb-4">
                        <DemoSlider images={property.imageUrls} address={property.address} type={property?.listingTypeId?.name} />
                      </div>
                      <div>
                        <button
                          className="btn btn-primary rounded mb-4 me-2"
                        >
                          {property?.propertyTypeId?.name}
                        </button>
                        <button
                          className="btn btn-primary rounded mb-4 me-2"
                        >
                          {property?.listingTypeId?.name}
                        </button>
                        <div className="d-md-flex d-block mb-sm-5 mb-4">
                          <div className="me-auto mb-md-0 mb-4">
                            <h3>
                              {property.title}
                            </h3>
                            <p>Posted on {moment(property.createdAt).format('MMM D, YYYY, h.mm A')}</p>
                            <span className="fs-16">
                              <svg
                                width={26}
                                height={26}
                                viewBox="0 0 26 26"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.9475 4.78947C8.94136 4.78947 7.02346 5.55047 5.61418 6.89569C4.20599 8.23987 3.42116 10.056 3.42116 11.9426C3.42116 14.7033 5.29958 17.3631 7.32784 19.4068C8.3259 20.4124 9.32653 21.2351 10.0786 21.8068C10.434 22.077 10.7326 22.29 10.9475 22.4389C11.1623 22.29 11.4609 22.077 11.8163 21.8068C12.5684 21.2351 13.569 20.4124 14.5671 19.4068C16.5954 17.3631 18.4738 14.7033 18.4738 11.9426C18.4738 10.056 17.689 8.23987 16.2808 6.89569C14.8715 5.55047 12.9536 4.78947 10.9475 4.78947ZM10.9475 23.2632C10.5801 23.8404 10.58 23.8403 10.5797 23.8401L10.5792 23.8398L10.5774 23.8387L10.5718 23.835L10.5517 23.8221C10.5345 23.8109 10.5097 23.7948 10.4779 23.7737C10.4143 23.7317 10.3224 23.6701 10.2063 23.5901C9.97419 23.43 9.64481 23.1959 9.25054 22.8962C8.46315 22.2977 7.41114 21.4333 6.35658 20.3707C4.27957 18.278 2.05273 15.2776 2.05273 11.9426C2.05273 9.67199 2.99797 7.50121 4.66932 5.90583C6.33959 4.31148 8.59845 3.42105 10.9475 3.42105C13.2965 3.42105 15.5554 4.31148 17.2256 5.90583C18.897 7.50121 19.8422 9.67199 19.8422 11.9426C19.8422 15.2776 17.6154 18.278 15.5384 20.3707C14.4838 21.4333 13.4318 22.2977 12.6444 22.8962C12.2501 23.1959 11.9207 23.43 11.6886 23.5901C11.5725 23.6701 11.4806 23.7317 11.417 23.7737C11.3979 23.7864 11.3814 23.7972 11.3675 23.8063C11.3582 23.8124 11.3501 23.8176 11.3432 23.8221L11.3232 23.835L11.3175 23.8387L11.3158 23.8398L11.3152 23.8401C11.315 23.8403 11.3148 23.8404 10.9475 23.2632ZM10.9475 23.2632L11.3148 23.8404C11.0907 23.983 10.8043 23.983 10.5801 23.8404L10.9475 23.2632Z"
                                  fill="#666666"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M10.9474 10.2632C9.81378 10.2632 8.89479 11.1822 8.89479 12.3158C8.89479 13.4494 9.81378 14.3684 10.9474 14.3684C12.0811 14.3684 13.0001 13.4494 13.0001 12.3158C13.0001 11.1822 12.0811 10.2632 10.9474 10.2632ZM7.52637 12.3158C7.52637 10.4264 9.05802 8.89474 10.9474 8.89474C12.8368 8.89474 14.3685 10.4264 14.3685 12.3158C14.3685 14.2052 12.8368 15.7368 10.9474 15.7368C9.05802 15.7368 7.52637 14.2052 7.52637 12.3158Z"
                                  fill="#666666"
                                />
                              </svg>
                              {property.address}
                            </span>
                          </div>
                          <div className="ms-md-4 text-md-right">
                            <p className="fs-14 text-black mb-1 me-1">
                              Price
                            </p>
                            <h4 className="fs-24 text-primary">
                              {/* {property?.priceUnitId?.name + " " +property.price} */}
                              ₹ {property?.priceUnitId?.name} {Number(property.price).toLocaleString()}
                            </h4>
                          </div>
                        </div>
                        {property?.propertyTypeId?.fields.includes("propertyFeatures") && (
                          <div className="mb-sm-5 mb-2">
                            <button
                              className="btn btn-primary light rounded me-2 mb-sm-0 mb-2"
                            >
                              <svg
                                className="me-2"
                                width={28}
                                height={19}
                                viewBox="0 0 28 19"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M23.1 8.03846C25.7498 8.03846 28 10.2859 28 13.1538V17.5385H25.9V19H24.5V17.5385H3.5V19H2.1V17.5385H0V13.1538C0 10.3876 2.17398 8.03846 4.9 8.03846H23.1ZM21.7 0C23.5821 0 25.2005 1.57962 25.2 3.65385L25.2005 7.14522C24.5639 6.78083 23.8517 6.57692 23.1 6.57692L21.7 6.57618C21.7 5.32466 20.7184 4.38462 19.6 4.38462H15.4C14.8622 4.38462 14.3716 4.59567 14.0001 4.94278C13.629 4.59593 13.1381 4.38462 12.6 4.38462H8.4C7.24044 4.38462 6.30038 5.36575 6.3 6.57619L4.9 6.57692C4.14851 6.57692 3.43653 6.7807 2.8 7.14488V3.65385C2.8 1.68899 4.3096 0 6.3 0H21.7ZM12.6 5.84579C12.9799 5.84579 13.3 6.21117 13.3 6.57692L7.7 6.57618C7.7 6.12909 8.04101 5.84615 8.4 5.84615L12.6 5.84579ZM19.6 5.85107C19.9961 5.84578 20.2996 6.20175 20.3 6.57618H14.7C14.7 6.1227 15.041 5.84615 15.4 5.84615L19.6 5.85107Z"
                                  fill="#3B4CB8"
                                />
                              </svg>
                              {property.numberOfBedrooms || 0} Bedroom
                            </button>
                            <button
                              className="btn btn-primary light rounded me-2 mb-sm-0 mb-2"
                            >
                              <svg
                                className="me-2"
                                width={19}
                                height={22}
                                viewBox="0 0 19 22"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M19 10.4211L18.6388 12.249C18.0616 15.1706 15.4406 17.3684 12.5829 17.3684H11.6923L13.4082 22H2.28779V10.4211H19ZM5.14753 0C6.68536 0 8.00727 1.29706 8.00727 2.89474V7.52632H18.8743V8.68421H8.00727V9.26316H1.1439L1.14378 11.0001C0.481336 10.4964 0 9.64309 0 8.68421V2.89474C0 1.33809 1.25234 0 2.85974 0H5.14753Z"
                                  fill="#3B4CB8"
                                />
                              </svg>
                              {property.numberOfBathrooms || 0} Bathroom
                            </button>
                            <button
                              className="btn btn-primary light rounded me-2 mb-sm-0 mb-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                fill="#3B4CB8"
                                className="me-2"
                              >
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M22 10h-4V7c0-1.66-1.34-3-3-3S12 5.34 12 7v3H2v2h2v9h2v-9h2v9h2v-9h2v9h2v-9h2v9h2v-9h2v-2zm-6 0h-4V7c0-1.1.9-2 2-2s2 .9 2 2v3z" />
                              </svg>
                              {property.numberOfBalconies || 0} Balcony
                            </button>
                            <button
                              className="btn btn-primary light rounded me-2 mb-sm-0 mb-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                fill="#3B4CB8"
                                className="me-2"
                              >
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M18 2.01 6 2c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4.01c0-1.1-.9-2-2-2zM8 5h2v4H8V5zm8 14H8v-6h8v6zm0-8H8V5h8v6z" />
                              </svg>

                              {property.numberOfKitchens || 0} Kitchen
                            </button>
                            <button
                              className="btn btn-primary light rounded mb-sm-0 mb-2"
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                height="24"
                                viewBox="0 0 24 24"
                                width="24"
                                fill="#3B4CB8"
                                className="me-2"
                              >
                                <path d="M0 0h24v24H0z" fill="none" />
                                <path d="M18.58 7h-.82l-.76-2.28c-.17-.51-.63-.72-1.05-.72H8.04c-.42 0-.88.21-1.05.72L6.23 7H5.42c-.65 0-1.18.53-1.18 1.18v11.6c0 .65.53 1.18 1.18 1.18h13.16c.65 0 1.18-.53 1.18-1.18V8.18C19.76 7.53 19.23 7 18.58 7zM8.28 8.5h7.44v2h-7.44V8.5zM7.5 16c-.83 0-1.5-.67-1.5-1.5S6.67 13 7.5 13s1.5.67 1.5 1.5S8.33 16 7.5 16zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5s1.5.67 1.5 1.5S17.33 16 16.5 16z" />
                              </svg>

                              {property.carParking || 0} Car Parking
                            </button>
                          </div>
                        )}
                        <h4>Description</h4>
                        {property.description}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card property-features">
                    <div className="card-header border-0 pb-0">
                      <h3 className="fs-20 text-black mb-0">Basic Details</h3>
                    </div>
                    <div className="card-body">
                      <ul>
                        {property?.propertyTypeId?.fields?.includes("furnishedStatus") && (
                          <li >
                            <i className="las la-check-circle" /> Furnished Status : {property?.furnishingStatusId?.name}
                          </li>
                        )}
                        <li >
                          <i className="las la-check-circle" /> Ownership Type : {property?.ownershipTypeId?.name}
                        </li>
                        <li >
                          <i className="las la-check-circle" /> Availability Status : {property?.availabilityStatusId?.name}
                        </li>
                        {property?.propertyTypeId?.fields?.includes("facingDirection") && (
                          <li >
                            <i className="las la-check-circle" /> Facing Direction : {property?.facingDirectionId?.name}
                          </li>
                        )}
                        {property?.propertyTypeId?.fields?.includes("propertyAge") && (
                          <li >
                            <i className="las la-check-circle" /> Property Age : {property?.propertyAge}
                          </li>
                        )}
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="col-xl-12">
                  <div className="card property-features">
                    <div className="card-header border-0 pb-0">
                      <h3 className="fs-20 text-black mb-0">Area Details</h3>
                    </div>
                    <div className="card-body">
                      <div className="mb-sm-5 mb-2">
                        {property?.propertyTypeId?.fields.includes("area") && (
                          <button
                            className="btn btn-primary light rounded me-2 mb-sm-2 mb-2"
                          >
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 4H4V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 4H20V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M7 20H4V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 20H20V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                            Area : {property.areaSize} {property.areaUnitId?.name}
                          </button>
                        )}
                        {property?.propertyTypeId?.fields.includes("carpetArea") && (
                          <button
                            className="btn btn-primary light rounded me-2 mb-sm-2 mb-2"
                          >
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 4H4V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 4H20V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M7 20H4V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 20H20V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                            Carpet Area : {property.carpetArea} {property.carpetAreaUnitId?.name}
                          </button>
                        )}
                        {property?.propertyTypeId?.fields.includes("buildUpArea") && (
                          <button
                            className="btn btn-primary light rounded me-2 mb-sm-2 mb-2"
                          >
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 4H4V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 4H20V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M7 20H4V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 20H20V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                            BuiltUp Area : {property.builtUpArea} {property.builtUpAreaUnitId?.name}
                          </button>
                        )}
                        {property?.propertyTypeId?.fields.includes("superBuildUpArea") && (
                          <button
                            className="btn btn-primary light rounded me-2 mb-sm-2 mb-2"
                          >
                            <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M7 4H4V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 4H20V7" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M7 20H4V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                              <path d="M17 20H20V17" stroke="#3B4CB8" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"></path>
                            </svg>
                            Super BuiltUp Area : {property.superBuiltUpArea} {property.superBuiltAreaUnitId?.name}
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {property.amenityIds.length > 0 && (
                  <div className="col-xl-12">
                    <div className="card property-features">
                      <div className="card-header border-0 pb-0">
                        <h3 className="fs-20 text-black mb-0">Amenities</h3>
                      </div>
                      <div className="card-body">
                        <ul>
                          {property.amenityIds.map(aminity => (
                            <li key={aminity._id}>
                              <i className="las la-check-circle" />
                              {aminity.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {property.featureIds.length > 0 && (
                  <div className="col-xl-12">
                    <div className="card property-features">
                      <div className="card-header border-0 pb-0">
                        <h3 className="fs-20 text-black mb-0">Features</h3>
                      </div>
                      <div className="card-body">
                        <ul>
                          {property.featureIds.map((feature) => (
                            <li key={feature._id}>
                              <i className="las la-check-circle" />
                              {feature.name}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}

                {property?.nearbyLandmarks?.length > 0 && (
                  <div className="col-xl-12">
                    <div className="card property-features">
                      <div className="card-header border-0 pb-0">
                        <h3 className="fs-20 text-black mb-0">Near by Landmarks</h3>
                      </div>
                      <div className="card-body">
                        <ul>
                          {property.nearbyLandmarks.map(landmark => (
                            <li key={landmark._id}>
                              <i className="las la-check-circle" />
                              {landmark.name + " " + landmark.value + " " + landmark.unit}
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}
export default PropertyDetails;